export const CleanupTabs = {
  Generate: 'Generate',
  Guide: 'Guide',
};
